import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_92yk6t891p: FaireBrandEntity = {
  token: "b_92yk6t891p",
  type: "brand",
  name: "to: little arrows",
  avatarUrl:
    "https://cdn.faire.com/fastly/49ef8782217f1283e54306b6d7e6dc9d0afcf3c038cbad640fb58d96ec7eae35.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3246308bdce311c2a3dc96e9331c9e721daf95889f3610216a335289d12b9ce0.png",
  logoUrl:
    "https://cdn.faire.com/fastly/49ef8782217f1283e54306b6d7e6dc9d0afcf3c038cbad640fb58d96ec7eae35.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3246308bdce311c2a3dc96e9331c9e721daf95889f3610216a335289d12b9ce0.png",
  location: "Sacramento, CA, USA",
  minimumOrderDollars: 80,
  rating: 4.9,
  reviewCount: 44,
  isTopShop: true,
  isInsider: true,
  description:
    "So why to: little arrows?\n\n- It’s a Love Letter - \nto: little arrows is truly a love letter to our children. Through this label we get to celebrate the best job ever of being their parents. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:00.925Z",
    importedBy: "entity-db-cli",
  },
};
